var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.vloading)?_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.vloading),expression:"vloading"}],staticClass:"ifram"}):_c('iframe',{staticClass:"ifram",attrs:{"src":_vm.url,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }